export default {
  fallbackLocale: 'en-GB',
}
